import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/table/index.js
// module id = 746
// module chunks = 0